"use strict";

require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
exports.Languages = function () {
  var langList = {
    pl: "pl-PL",
    en: "en-GB"
  };
  var currentKey = $("#meta_language").attr("content") || 'pl';
  return {
    langList: langList,
    Current: {
      key: currentKey,
      code: langList[currentKey]
    }
  };
}();
exports.getCurrentLanguage = function () {
  return $("#meta_language").attr("content") || 'pl';
  var url = window.location.href;
  var lang = url.toString().split('/')[3];
  return lang;
}();
exports.getCurrentLanguageUrl = function () {
  var lang = $("#meta_language").attr("content") || 'pl';
  if (lang == 'pl') {
    return '';
  }
  return "/" + lang;
}();